import{__require as a}from"./similar.js";var i=function(r){if(typeof Map!="function"||r){var e=a();return new e}else return new Map};export{i as default};
